import { ROUTE_ADMIN_PATH } from 'routes';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import {
  Home, LineChart, Settings, Users, Briefcase, MessageSquareText,
  BarChart3, Printer, Puzzle, BookOpen, Info, Landmark,
} from 'lucide-react';

const useAdminRows = (rolePath, subMenu, handleShowSubmenu) => {
  const literals = useSelector(state => state.i18n.literals.leftMenu);
  const platform = useSelector(state => state.global.platform);

  const navRows = useMemo(() => (rolePath === 'admin' ? {
    upper: [
      {
        path: ROUTE_ADMIN_PATH.HOME,
        to: ROUTE_ADMIN_PATH.HOME,
        name: literals.summary,
        icon: Home,
        exact: true,
      },
      {
        canView: !!platform?.analytics?.ga4?.property,
        path: ROUTE_ADMIN_PATH.ANALYTICS,
        to: ROUTE_ADMIN_PATH.ANALYTICS,
        name: literals.analytics,
        icon: LineChart,
      },
      {
        path: ROUTE_ADMIN_PATH.PLATFORM,
        to: ROUTE_ADMIN_PATH.PLATFORM,
        name: literals.platform,
        icon: Settings,
      },
      {
        path: ROUTE_ADMIN_PATH.USERS,
        to: ROUTE_ADMIN_PATH.USERS,
        name: literals.userAccess,
        icon: Users,
      },
      {
        path: ROUTE_ADMIN_PATH.STARTUPS,
        to: ROUTE_ADMIN_PATH.STARTUPS,
        name: literals.companies,
        icon: Briefcase,
      },
      {
        path: ROUTE_ADMIN_PATH.FUNDRAISE,
        to: ROUTE_ADMIN_PATH.FUNDRAISE,
        name: literals.fundraise,
        icon: Landmark,
      },
      {
        path: ROUTE_ADMIN_PATH.MENTORINGS,
        to: ROUTE_ADMIN_PATH.MENTORINGS,
        name: literals.mentorings,
        icon: MessageSquareText,
      },
      {
        path: ROUTE_ADMIN_PATH.PERFORMANCE,
        to: ROUTE_ADMIN_PATH.PERFORMANCE,
        name: literals.performance,
        icon: BarChart3,
      },
      {
        path: ROUTE_ADMIN_PATH.REPORTING,
        to: ROUTE_ADMIN_PATH.REPORTING,
        name: literals.reporting,
        icon: Printer,
      },
      {
        path: ROUTE_ADMIN_PATH.SERVICES,
        to: ROUTE_ADMIN_PATH.SERVICES,
        name: literals.services,
        icon: Puzzle,
      },
      {
        path: [ROUTE_ADMIN_PATH.WEBHOOKS, ROUTE_ADMIN_PATH.SCRIPTS, ROUTE_ADMIN_PATH.CRONS],
        name: literals.logs,
        icon: BookOpen,
        subMenu: [
          { path: ROUTE_ADMIN_PATH.WEBHOOKS, to: ROUTE_ADMIN_PATH.WEBHOOKS, name: literals.webhooks },
          { path: ROUTE_ADMIN_PATH.SCRIPTS, to: ROUTE_ADMIN_PATH.SCRIPTS, name: literals.scripts },
          { path: ROUTE_ADMIN_PATH.CRONS, to: ROUTE_ADMIN_PATH.CRONS, name: literals.crons },
        ],
        showSubmenu: subMenu === 'logs',
        handleShowSubmenu: () => handleShowSubmenu('logs'),
      },
      {
        path: ROUTE_ADMIN_PATH.SUPPORT,
        to: ROUTE_ADMIN_PATH.SUPPORT,
        name: literals.help,
        icon: Info,
      },
    ],
  // eslint-disable-next-line react-hooks/exhaustive-deps
  } : {}), [subMenu, platform?.analytics?.ga4?.property, rolePath]);

  return navRows;
};

export default useAdminRows;
